module.exports = __webpack_public_path__ + "img/message-center.8bbf71cf.svg";